import AgentNotificationConfigDomain from "entities/domain/agents/agent-notification-config-domain";
import { MerchantAgentPermissionDomain } from "./merchant-agent-permission-domain";
import { MerchantAgentRoleDomain } from "./merchant-agent-role-domain";
import { MerchantAgentStylePreferences } from "./merchant-agent-style-preferences";

export default class MerchantAgentDomain {
  id: number;
  name: string;
  surname: string;
  email: string;
  phone: string;
  preferredContactChannel: string;
  notificationConfig: AgentNotificationConfigDomain | null;
  merchantId: number;
  userId: string;
  profilePic: string;
  color: string;
  role: MerchantAgentRoleDomain | null;
  permissions: MerchantAgentPermissionDomain[] | null;
  active: boolean;
  rotationEnabled: boolean;
  playerIds: string[] | null;
  stylePreferences: MerchantAgentStylePreferences | null;
  lastActiveAt: Date | null;
  mfaEnrolledAt: Date | null;

  constructor(params: {
    id: number;
    name: string;
    surname: string;
    email: string;
    phone: string;
    preferredContactChannel: string;
    notificationConfig: AgentNotificationConfigDomain | null;
    merchantId: number;
    userId: string;
    profilePic: string;
    color: string;
    role: MerchantAgentRoleDomain | null;
    permissions: MerchantAgentPermissionDomain[] | null;
    active: boolean;
    rotationEnabled: boolean;
    playerIds: string[] | null;
    stylePreferences: MerchantAgentStylePreferences | null;
    lastActiveAt: Date | null;
    mfaEnrolledAt: Date | null;
  }) {
    this.id = params.id;
    this.name = params.name;
    this.surname = params.surname;
    this.email = params.email;
    this.phone = params.phone;
    this.preferredContactChannel = params.preferredContactChannel;
    this.notificationConfig = params.notificationConfig;
    this.merchantId = params.merchantId;
    this.userId = params.userId;
    this.profilePic = params.profilePic;
    this.color = params.color;
    this.role = params.role;
    this.permissions = params.permissions;
    this.active = params.active;
    this.rotationEnabled = params.rotationEnabled;
    this.playerIds = params.playerIds;
    this.stylePreferences = params.stylePreferences;
    this.lastActiveAt = params.lastActiveAt;
    this.mfaEnrolledAt = params.mfaEnrolledAt;
  }

  public getFullName(): string {
    return `${this.name} ${this.surname}`;
  }

  public getPicture() {
    if (this.profilePic && this.profilePic !== "null") {
      return this.profilePic;
    }

    return "";
  }
}
